document.addEventListener('DOMContentLoaded', function() {
  /**
   * keco product videos
   */
  /* autoplay gallery videos on click */
  var videoGalleryLinks = document.querySelectorAll('.keco-product-video-gallery a');
  videoGalleryLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var embedUrl = this.getAttribute('data-embed-url') + '?autoplay=1';
      var iframe = document.querySelector('.keco-product-video iframe');
      iframe.setAttribute('src', embedUrl);
    });
  });

  /**
   * make the Tools top level nav not clickable
   */
  document.querySelector('.full-menu a[href="/collections/all"]').setAttribute('href', '#')
});